import React, { PropTypes } from 'react';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
} from 'material-ui/Table';
import _l from 'lodash';

import BrandListRow from './BrandListRow';

const styles = {
  table: {
    column: {
      name: {
        width: 90,
      },
      status: {
        width: 50,
      },
      order: {
        width: 50,
      },
    },
  }
};

const BrandList = ({ brands, onChange, onDelete }) => {
  return (
    <Table
      selectable={false}>
      <TableHeader
        adjustForCheckbox={false}
        displaySelectAll={false}>
        <TableRow>
          <TableHeaderColumn style={styles.table.column.name}>中文名稱</TableHeaderColumn>
          <TableHeaderColumn style={styles.table.column.name}>英文名稱</TableHeaderColumn>
          <TableHeaderColumn style={styles.table.column.status}>狀態</TableHeaderColumn>
          <TableHeaderColumn style={styles.table.column.order}>排序</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody
        displayRowCheckbox={false}>
        {
          _l.map(brands, (brand, index) =>
            <BrandListRow key={index}
                          brand={brand}
                          rowStyles={styles.table}
                          onChange={onChange.bind(this, index)}
                          onDelete={onDelete.bind(this, index)} />
          )
        }
      </TableBody>
    </Table>
  );
};

BrandList.propTypes = {
  brands: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default BrandList;


// WEBPACK FOOTER //
// client/adminPanel/panel/brands/BrandList.js